import React, { FC, useState } from 'react';
import s from './toyCartItem.module.scss';
import { SelectedItem } from './SelectedItem';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { useGetToy } from '@hooks/TRPC_Hooks/useGetToy';
import dynamic from 'next/dynamic';
import { useGetSingleCollection } from '@hooks/TRPC_Hooks/useGetSingleCollection';
import { ToysCartItemLoader } from './ToysCartItemLoader';
import { Button } from '@components/UIKit/Button/Button';
import { Checkbox } from '@components/UIKit/Checkbox/Checkbox';
import { useTranslation } from '@hooks/useTranslation';
import { ToyCartItemRemove } from '@components/Cards/ToyCartItem/ToyCartItemRemove';
import { replaceQuery } from '@specs/navigation';
import { Counter } from '@components/Cards/Counter/Counter';
import { ICartItemToys, addToysToCart } from '@services/store/helpers/cart';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const CartAvailable = dynamic(import('@components/Modals/Variants/CartAvailable/CartAvailable').then(module => module.CartAvailable), {
  ssr: false
});
interface ToysCartItemProps {
  setSelectedFigures: React.Dispatch<React.SetStateAction<ICartItemToys[]>>;
  selectedFigures: ICartItemToys[];
  toyCartItem: ICartItemToys;
  deleteHandler: () => void;
  setList: React.Dispatch<React.SetStateAction<ICartItemToys[]>>;
  listLength: number;
  buyOneHandler: (figure: ICartItemToys['figures'][0]) => void;
}
export const ToyCartItem: FC<ToysCartItemProps> = ({
  setSelectedFigures,
  selectedFigures,
  setList,
  deleteHandler,
  toyCartItem,
  buyOneHandler,
  listLength
}) => {
  const {
    toyId,
    figures
  } = toyCartItem;
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const {
    data: toy,
    isLoading: toyLoading
  } = useGetToy({
    id: toyId
  });
  const collectionId = toy?.collections?.[0]?.collectionid;
  const {
    data: collection,
    isLoading: collectionLoading
  } = useGetSingleCollection({
    id: collectionId ?? -1
  }, {
    enabled: typeof collectionId !== 'undefined'
  });
  const isLoading = toyLoading || typeof collectionId !== 'undefined' && collectionLoading;
  if (isLoading) return <ToysCartItemLoader {...toyCartItem} />;
  if (!toy) return null;
  const removeStoreItem = (storeItemId: number) => {
    setList(prev => {
      const cartItem = prev.find(item => item.figures.flatMap(item => item.storeItemId).includes(storeItemId))!;
      const data = cartItem.figures.length === 1 ? prev.filter(item => item.toyId !== cartItem.toyId) : prev.map(item => item.toyId !== cartItem.toyId ? item : {
        ...item,
        figures: item.figures.filter(figure => figure.storeItemId !== storeItemId)
      });
      addToysToCart(data);
      return data;
    });
    const cartItem = selectedFigures.find(item => item.figures.flatMap(item => item.storeItemId).includes(storeItemId));
    if (!!cartItem) {
      setSelectedFigures(prev => prev.map(item => item.toyId !== cartItem.toyId ? item : cartItem.figures.length === 1 ? undefined : {
        ...item,
        figures: item.figures.filter(figure => figure.storeItemId !== storeItemId)
      }).filter(item => !!item) as ICartItemToys[]);
    }
  };
  const onClose = () => {
    setIsOpenModal(false);
  };
  const closeHandler = async () => {
    onClose();
    await replaceQuery(router, {
      storeItemsSort: undefined,
      query: undefined
    });
  };
  const countHandler = (variant: boolean) => {
    variant ? setIsOpenModal(true) : removeStoreItem(figures.slice(0, 1)[0].storeItemId);
  };
  const onChangeHandler = () => {
    setSelectedFigures(prev => {
      const isSelected = prev.some(cartItem => cartItem.toyId === toyId);
      return isSelected ? prev.filter(cartItem => cartItem.toyId !== toyId) : [...prev, toyCartItem];
    });
  };
  const checked = selectedFigures.some(figure => figure.toyId === toyId);
  const {
    imageid,
    name
  } = toy;
  return <>
            <div className={s.toyCartItem}>
                <div className={s.toyCartItem__box}>
                    <div className={s.toyCartItem__left}>
                        {listLength > 1 && <Checkbox className={s.toyCartItem__checkbox} onChange={onChangeHandler} checked={checked} name={`cart_toy_id_${toyId}`} />}
                        <div className={s.toyCartItem__toy}>
                            <OptimizedImage boxClassName={cn(s.toyCartItem__image, '_shadow')} path={'/toys/cards'} cdnId={imageid} alt={name} fill data-sentry-element="OptimizedImage" data-sentry-source-file="ToyCartItem.tsx" />
                            <div className={s.toyCartItem__body}>
                                <div className={s.toyCartItem__header}>
                                    <div className={s.toyCartItem__info}>
                                        <div className={cn(s.toyCartItem__name, '_ellipsis')}>{name}</div>
                                        {collection && <div className={cn(s.toyCartItem__collection, '_ellipsis')}>{collection.name}</div>}
                                    </div>
                                    <ToyCartItemRemove className={'_mobile'} clickHandler={deleteHandler} data-sentry-element="ToyCartItemRemove" data-sentry-source-file="ToyCartItem.tsx" />
                                </div>
                                <Counter className={s._hideBeforeContainerMedia} count={figures.length} countHandler={countHandler} data-sentry-element="Counter" data-sentry-source-file="ToyCartItem.tsx" />
                                {figures.length === 1 && <Button id='toy_cart_buy_only_toy' size={'small'} color={'Zhen Zhu Bai Pearl'} onClick={() => {
                buyOneHandler(figures[0]);
              }} icons={{
                left: {
                  name: 'light'
                }
              }}>
                                        {tr({
                  id: 'cart.page.buy.this.toy.only'
                })}
                                    </Button>}
                            </div>
                        </div>
                    </div>
                    <Counter className={s._hideAfterContainerMedia} count={figures.length} countHandler={countHandler} data-sentry-element="Counter" data-sentry-source-file="ToyCartItem.tsx" />
                    <div className={s.toyCartItem__right}>
                        <ToyCartItemRemove className={'_desktop'} clickHandler={deleteHandler} data-sentry-element="ToyCartItemRemove" data-sentry-source-file="ToyCartItem.tsx" />
                        <div className={s.toyCartItem__list}>
                            {figures.map(figure => <SelectedItem key={figure.storeItemId} figure={figure} editHandler={() => {
              setIsOpenModal(true);
            }} />)}
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={isOpenModal} onClose={onClose} data-sentry-element="Modal" data-sentry-source-file="ToyCartItem.tsx">
                <CartAvailable toyId={toyId} figures={figures} closeHandler={closeHandler} setSelectedFigures={setSelectedFigures} setList={setList} data-sentry-element="CartAvailable" data-sentry-source-file="ToyCartItem.tsx" />
            </Modal>
        </>;
};